import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns'
import esLocale from 'date-fns/locale/es'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import { Calendar } from 'lucide-react'
import i18n from '../../../assets/i18n'
import { tokens } from '../../../assets/tokens'
import SingleDatePickerStyled from './styled'

// Mismo selector que DateRangePiker (MUI pickers) en lugar de react-dates. La API no cambia:
// la fecha entra y sale como moment, o null al vaciarla.
const SingleDate = ({ date, onDateChange, onFocusChange, isFetching, readOnly = false, minDate, placeholder, id = 'startDate_id' }) => {
  // Mientras se escribe a mano el picker manda fechas inválidas: solo se propagan las completas
  const handleChange = value => {
    if (!onDateChange) return
    if (value === null) return onDateChange(null)
    if (!isNaN(value.getTime())) onDateChange(moment(value))
  }

  const value = date && moment(date).isValid() ? moment(date).toDate() : null

  return (
    <SingleDatePickerStyled>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
        <KeyboardDatePicker
          autoOk
          disableToolbar
          fullWidth
          variant="inline"
          inputVariant="outlined"
          format="dd/MM/yyyy"
          id={id}
          value={value}
          placeholder={placeholder || i18n.statisticsItems.startDate}
          minDate={minDate || undefined}
          onChange={handleChange}
          onOpen={() => onFocusChange && onFocusChange({ focused: 'startDate' })}
          onClose={() => onFocusChange && onFocusChange({ focused: '' })}
          disabled={isFetching || readOnly}
          keyboardIcon={<Calendar size={18} color={tokens.color.text.tertiary} />}
          KeyboardButtonProps={{ size: 'small' }}
        />
      </MuiPickersUtilsProvider>
    </SingleDatePickerStyled>
  )
}

SingleDate.propTypes = {
  date: PropTypes.object,
  onDateChange: PropTypes.func,
  focused: PropTypes.string,
  onFocusChange: PropTypes.func,
  isFetching: PropTypes.bool,
  readOnly: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  placeholder: PropTypes.string,
  id: PropTypes.string
}

export default SingleDate
